/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createAdminProgram } from '../fn/admin-programs/create-admin-program';
import { CreateAdminProgram$Params } from '../fn/admin-programs/create-admin-program';
import { findOneAdminProgram } from '../fn/admin-programs/find-one-admin-program';
import { FindOneAdminProgram$Params } from '../fn/admin-programs/find-one-admin-program';
import { listAdminPrograms } from '../fn/admin-programs/list-admin-programs';
import { ListAdminPrograms$Params } from '../fn/admin-programs/list-admin-programs';
import { Program } from '../models/program';
import { updateAdminProgram } from '../fn/admin-programs/update-admin-program';
import { UpdateAdminProgram$Params } from '../fn/admin-programs/update-admin-program';

@Injectable({ providedIn: 'root' })
export class AdminProgramsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminProgramControllerListAdminPrograms()` */
  static readonly AdminProgramControllerListAdminProgramsPath = '/admin/programs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAdminPrograms()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdminPrograms$Response(
    params?: ListAdminPrograms$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<Program>>> {
    return listAdminPrograms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAdminPrograms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdminPrograms(params?: ListAdminPrograms$Params, context?: HttpContext): Observable<Array<Program>> {
    return this.listAdminPrograms$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Program>>): Array<Program> => r.body)
    );
  }

  /** Path part for operation `adminProgramControllerCreateAdminProgram()` */
  static readonly AdminProgramControllerCreateAdminProgramPath = '/admin/programs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAdminProgram()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdminProgram$Response(
    params: CreateAdminProgram$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Program>> {
    return createAdminProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAdminProgram$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdminProgram(params: CreateAdminProgram$Params, context?: HttpContext): Observable<Program> {
    return this.createAdminProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Program>): Program => r.body)
    );
  }

  /** Path part for operation `adminProgramControllerFindOneAdminProgram()` */
  static readonly AdminProgramControllerFindOneAdminProgramPath = '/admin/programs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findOneAdminProgram()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneAdminProgram$Response(
    params: FindOneAdminProgram$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Program>> {
    return findOneAdminProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findOneAdminProgram$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findOneAdminProgram(params: FindOneAdminProgram$Params, context?: HttpContext): Observable<Program> {
    return this.findOneAdminProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Program>): Program => r.body)
    );
  }

  /** Path part for operation `adminProgramControllerUpdateAdminProgram()` */
  static readonly AdminProgramControllerUpdateAdminProgramPath = '/admin/programs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAdminProgram()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdminProgram$Response(
    params: UpdateAdminProgram$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Program>> {
    return updateAdminProgram(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAdminProgram$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdminProgram(params: UpdateAdminProgram$Params, context?: HttpContext): Observable<Program> {
    return this.updateAdminProgram$Response(params, context).pipe(
      map((r: StrictHttpResponse<Program>): Program => r.body)
    );
  }
}
